import { Directive, Output, EventEmitter, HostListener, OnInit, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[abbClearInput]'
})
export class ClearInputDirective implements OnInit {

  @Output() clear:EventEmitter<void> = new EventEmitter<void>(false);


  @HostListener('click', ['$event'])
  onClick(_evnt) {

    if(confirm("Do you want to clear this input ?") == true){
      if(this.clear){
        this.clear.emit();
      }
    }

    _evnt.stopPropagation();
  }

  constructor(public renderer:Renderer2, public hostElement: ElementRef) { 
  }

  ngOnInit(){
    this.renderer.setAttribute(this.hostElement.nativeElement, 'title','Click to Clear');

  }

}
